import Logo from "../../assets/images/logo-icon.png";
import "./Creditztype.css";
import { Row, Col } from "react-bootstrap";
import Audio from "../../assets/images/AddCreditzAudio.jpg";
import Video from "../../assets/images/AddCreditzVideo.jpg";
import { useState } from "react";
import video from "../settings/settingsTabs/video";



const CreditzType = ({ updateCategory }) => {


  const [activeImage, setActiveImage] = useState({
    id:null,
    categories:[
      {category:'Music', name:'Audio', pic:Video},
      {category:"Youtube Video", name:'Video', pic:Audio},
   ]
  })

  function imageClickHandler(category, idx){
    updateCategory(category);
    setActiveImage({...activeImage, id:idx});
  }

   

  return (
    <div className="card border-0 rounded-xl shadow-xs">
      <div>
        <img className="center" src={Logo}></img>
      </div>
      <div
        style={{ textAlign: "center", marginTop: "15px", paddingTop: "5px" }}
      >
        <h5 className="fs-22 fw-bold mb-0" class="heading" > Please Select Creditz Type</h5>
      </div>
      <Row style={{ marginTop: "10px", marginBottom: "25px" }}>
        {activeImage.categories.map(({category, name, pic}, idx) => {
          const effect = activeImage.id===idx ? 'effect':"";
          return(

            <Col md="6" sm="12" key={idx} >
          <div class="container"  onClick={() => imageClickHandler(category, idx)}>
            <img
              style={{ height: "250px", width: "250px", opacity: 0.7,
               borderRadius: "15px", paddingTop: "0px",
               opacity:`${effect?0.4:1}`
            
            }}
              className={`center effect2 ${effect}`}
              class='effect2'
              src={pic}
            ></img>
            <div class="centered" >
              <h5 style={{ color: `${effect?'purple':'white'}`, zIndex:`${effect?5:1}`, opacity:`${effect?1:1}` }} className="fs-30 fw-bold mb-0"  class='image-heading'>
                {name}
              </h5>
            </div>
          </div>
        </Col>
          )
        })}

        {/* <Col md="6" sm="12" >
          <div class="container"  onClick={() => updateCategory("Music")}>
            <img
              style={{ height: "250px", width: "250px", opacity: 0.7, borderRadius: "15px", paddingTop: "0px"}}
              className="center effect"
              src={Video}
            ></img>
            <div class="centered" >
              <h5 style={{ color: "white" }} className="fs-30 fw-bold mb-0"  class='image-heading'>
                Audio
              </h5>
            </div>
          </div>
        </Col>
        <Col md="6" sm="12">
          <div
            class="container"
            onClick={() => updateCategory("Youtube Video")}
           
          >
            <img
              style={{ height: "250px", width: "250px", opacity: 0.7, borderRadius: "15px", paddingTop: "0px"}}
              className="center effect"
              src={Audio}
            ></img>
            <div class="centered">
              <h5 style={{ color: "white" }} className="fs-30 fw-bold mb-0" class='image-heading'>
                Video
              </h5>
            </div>
          </div>
        </Col> */}
      </Row>
      <div className="card-body p-3 p-sm-4"></div>
    </div>
  );
};

export default CreditzType;
